import React, { useCallback, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
// import animatedScroll from "animated-scroll-to";
import { AccordionStyled, AccordionTitle, Divider} from "./Accordion.Styled";
import { applyKey } from "../../../utils";


const AccordionItem = (props) => {
  const { children, title, hasSelected, onSelected } = props;

  const ref = useRef(null);

  const onSelectedHandle = useCallback(
    (item) => {
      if (item) {
        onSelected(item);
      }
    },
    [onSelected]
  );

  useEffect(() => {
    if (hasSelected) {
      onSelectedHandle(ref.current);
    }

    return () => {
      onSelectedHandle(null);
    };
  }, [hasSelected, onSelectedHandle]);

  return (
    <>
      <span ref={ref} style={{ display: "none !important" }} />
      <AccordionStyled.Item
        {...props}
        title={title}
        className="Accordion__Item make-click"
        data-label={title}
      >
        <AccordionStyled.ItemBody className="Accordion__Body">
          {children}
        </AccordionStyled.ItemBody>
      </AccordionStyled.Item>
      <Divider />
    </>
  );
};

AccordionItem.defaultProps = {
  onSelected: (ref) => ref,
  hasSelected: false,
};

AccordionItem.propTypes = {
  onSelected: PropTypes.func,
  hasSelected: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

const Accordion = ({ listItems, className, forEmpty, onChange, titleAccordion }) => {
  const [selected, setSelected] = useState(-1);

  const onChangeHandle = useCallback((index) => {
    setSelected(index);
  }, []);

  const onSelectedHandle = useCallback(
    (selectedItem) => {
      // const { ref } = { ...selectedItem };

      // if (ref) {
      //   animatedScroll(ref, {
      //     verticalOffset: -70,
      //   });
      // }
      onChange(selectedItem);
    },
    [onChange]
  );

  return (
    <AccordionStyled className={className} onChange={onChangeHandle}>
      <AccordionTitle>{titleAccordion}</AccordionTitle>
      {(listItems || []).length
        ? applyKey(listItems, ({ title, body }, index) => {
            return (
              <AccordionItem
                title={title}
                hasSelected={selected === index}
                onSelected={(ref) =>
                  onSelectedHandle({ ref, title, body, index })
                }
              >
                {body}
              </AccordionItem>
            );
          })
        : forEmpty}
    </AccordionStyled>
  );
};

Accordion.defaultProps = {
  forEmpty: null,
  onChange: (item) => item,
  titleAccordion: ''
};

Accordion.propTypes = {
  listItems: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      body: PropTypes.element.isRequired,
    })
  ).isRequired,
  forEmpty: PropTypes.element,
  onChange: PropTypes.func,
  titleAccordion: PropTypes.string,
};

export default Accordion;
